import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/app/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5f4af2ac425bb079ca192ef1628618b1.js')["default"];

var scope_1 = require('/app/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/602f01414a0191514a6c401cb51b5db3.js')["default"];

var scope_2 = require('/app/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/605de4b14dcc86b132b95752e49e8d88.js')["default"];

var scope_3 = require('/app/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8d0f74ef301c4113166e0dc14b3c2c4d.js')["default"];

var scope_4 = require('/app/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9e450e2d9263a24be88ab3c9506aa0b3.js')["default"];

var scope_5 = require('/app/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9fb5ec180469605c662b3823dec6ac26.js')["default"];

var scope_6 = require('/app/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js')["default"];

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}